import {urls, api} from '@/api'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({
  id: null,
  info: {},
  followers: null,
  following: [],
  isFollowed: false,
  publications: [],
  page: 1,
  per_page: 25,
  totalPages: null,
  totalPubs: null,
  aggregations: {}
})

const state = getInitialState()

const actions = {
  cleanProfile: ({commit}) => {
    commit(types.PROFILE_RESET_STATE)
    return Promise.resolve()
  },

  fetchProfile: ({commit, state}, id) => {

    // Extract user role from first publication (if available)
    const userRole = state.publications.length > 0
      ? (state.publications[0].user && state.publications[0].user.role)
      : null

    // Skip if no publications (no user role available)
    if (!userRole) {
      return Promise.resolve()
    }

    // Skip if user is not commerce
    if (userRole !== 'COMMERCE') {
      return Promise.resolve()
    }

    // Fetch profile only for commerce users
    return api.get(`${urls.profile}/${id}`)
      .then(({data}) => { commit(types.PROFILE_SET_INFO, data.data) })
      .catch(er => {})
  },

  fetchPublications: ({commit, state}, params) => {
    if (params.page) commit(types.PROFILE_SET_PAGE, params.page)
    else params.page = state.page
    params.per_page = state.per_page

    return api.get(urls.publicationSearch, { params })
      .then(({data}) => {
        const aggregations = Array.isArray(data.aggregations) ? {} : data.aggregations

        commit(types.PROFILE_SET_PUBLICATIONS, data.data)
        commit(types.PROFILE_SET_TOTAL_PAGES, data.meta.pagination.total_pages)
        commit(types.PROFILE_SET_TOTAL_PUBS, data.meta.pagination.total)
        commit(types.PROFILE_SET_AGGREGATIONS, aggregations)
      })
      .catch(er => {})
  },

  fetchFollowers: ({commit, state, rootState}, id) => {
    const isAuth = rootState.user.isAuth
    // Hidden amount of followers temporarily (?) due to most users not having followers
    if (!isAuth) return
    const userId = id || state.id || rootState.publication.userId
    // Still calling private endpoint to know if user follows seller
    // const endpoint = isAuth ? `/api/users/${userId}/followers-count/` : `/api/users/${userId}/public-followers-count`
    const endpoint = `${urls.users}/${userId}/followers-count/`

    return api.get(endpoint)
      .then(({data}) => {
        // here and extra extra data
        const followers = data.data && data.data.data && data.data.data.followers
        const followed = data.data && data.data.data && data.data.data.followed

        commit(types.PROFILE_SET_FOLLOWERS, followers)
        if (followed !== undefined) commit(types.PROFILE_SET_FOLLOW_STATUS, followed)
      })
      .catch(er => {})
  },

  fetchFollowing: ({commit}, id) => api.get(urls.profileFollowing, { params: { user_id: id } })
    .then(({data}) => { commit(types.PROFILE_SET_FOLLOWING, data.data) })
    .catch(er => {}),

  follow: ({commit, dispatch}, id) => api.post(urls.profileFollowing, { user_id: id })
    .then(({data}) => {
      return dispatch('fetchFollowers', id)
    })
    .catch(er => {}),

  unfollow: ({commit, dispatch}, id) => api.delete(`${urls.profileFollowing}/${id}`)
    .then(({data}) => { return dispatch('fetchFollowers', id) })
    .catch(er => { return Promise.reject(er) }),

  setPage: ({commit}, page) => { commit(types.PROFILE_SET_PAGE, page) },
}

const mutations = {
  [types.PROFILE_SET_PUBLICATIONS] (state, publications) {
    state.publications = publications || []
  },

  [types.PROFILE_SET_INFO] (state, info) {
    state.info = info || {}
  },

  [types.PROFILE_SET_AGGREGATIONS] (state, aggregations) {
    state.aggregations = aggregations || {}
  },

  [types.PROFILE_SET_FOLLOW_STATUS] (state, status) {
    state.isFollowed = status
  },

  [types.PROFILE_SET_FOLLOWERS] (state, followers) {
    state.followers = followers
  },

  [types.PROFILE_SET_FOLLOWING] (state, following) {
    state.following = following
  },

  [types.PROFILE_RESET_STATE] (state) {
    Object.assign(state, getInitialState())
  },

  [types.PROFILE_SET_PAGE] (state, page) {
    state.page = parseInt(page)
  },

  [types.PROFILE_SET_TOTAL_PAGES] (state, total) {
    state.totalPages = total
  },

  [types.PROFILE_SET_TOTAL_PUBS] (state, total) {
    state.totalPubs = total
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js